import classNames from 'classnames'
import styled, {css} from 'quickstart/styled-components/system'

/**
 * The root element of every block-configuration form.
 *
 * Classic's dialog typography is asserted here because the classic admin sets
 * verdana at `font-size: medium` on `body` and its dialogs step that down; a
 * React root inside one would otherwise render at body size. `button` and `p`
 * are named separately because neither inherits font from an ancestor.
 *
 * Under the reskin nothing is declared. The admin's own `body` supplies
 * `--t-font` at `--t-text-base`, and the classes this project renders into
 * carry their own type where it differs (`.t-button`, `.t-field-lbl-txt`,
 * `.t-input`). Re-asserting a font here would be reproducing an appearance
 * the admin owns, which is what this change exists to stop — and it would
 * apply verdana at 10.9px to every reskin control in every form.
 *
 * Under the reskin it also supplies the form's own layout parent — a
 * `.t-stack` at `data-gap="5"`, the 20px the object editor spaces a design-tab
 * section's property rows by (`.object-props-list`) — so a form stated once
 * here cannot omit it by forgetting, and a form rendering a single root
 * (`A.Tabs`, a lone group) makes it inert by construction: a gap between one
 * child and nothing is no gap. Classic keeps its groups' own margins and gets
 * no class here.
 */
export const AdminWrapper = styled.div.attrs<{$reskin?: boolean}>(
  ({$reskin, className}) => ({
    className: classNames($reskin && 't-stack', className),
    ...($reskin && {'data-gap': '5'}),
  }),
)<{$reskin?: boolean}>(({$reskin}) =>
  $reskin
    ? null
    : css`
        && {
          font-family: verdana, sans-serif;
          font-size: 0.68rem;
          button,
          p {
            font-family: verdana, sans-serif;
            font-size: 0.68rem;
          }
        }
      `,
)
